module.exports = __webpack_public_path__ + "img/turk5.49c0c3d3.jpg";